<div id="scenariosModal" tabindex="-1" aria-labelledby="scenariosModal" aria-modal="true">
    <ng-container *ngIf="isOpen">
        <div class="modal-header">
            <h4 [hidden]="viewMode != 'list'" class="modal-title">
                Enregistrements
                <span *ngIf="currentScenario.isLoaded"> - {{ currentScenario.name }} </span>
            </h4>
            <h4 [hidden]="viewMode != 'create'" class="modal-title">Nouvel enregistrement</h4>
            <h4 [hidden]="viewMode != 'update'" class="modal-title">
                Mise à jour des informations de l'enregistrement
            </h4>
        </div>

        <div class="modal-body">
            <div [hidden]="viewMode != 'list'">
                <div class="container-fluid mb-4">
                    <div class="row">
                        <div class="col-6 ps-0 new-study">
                            <h5 class="st-fw-bold mt-0">Enregistrer une nouvelle étude</h5>

                            <stButton
                                btnLabel="Enregistrer sous"
                                btnClass="btn-st-primary"
                                iconLeft
                                iconLeft="fa fa-floppy-o pe-3"
                                (click)="create()"
                                [isDisabled]="currentScenario.isLoading"
                            ></stButton>

                            <span class="ms-4">
                                <i
                                    [hidden]="!waiter.create.progress"
                                    class="fa fa-spinner fa-spin fa-lg fa-fw"
                                ></i>
                                <i
                                    [hidden]="!waiter.create.ok"
                                    class="fa fa-check fa-lg text-st-success"
                                    aria-hidden="true"
                                ></i>
                                <i
                                    [hidden]="!waiter.create.error"
                                    class="fa fa-exclamation-triangle fa-lg text-st-danger"
                                    aria-hidden="true"
                                ></i>
                            </span>
                        </div>

                        <div
                            class="col-6 pe-0 replace-study"
                            *ngIf="!currentScenario.isLoading && currentScenario.isLoaded && isScenarioAvailable(user, currentScenario)"
                        >
                            <h5 class="st-fw-bold mt-0">Mettre à jour l'étude en cours</h5>

                            <stButton
                                btnLabel="Enregistrer"
                                btnClass="btn-st-primary"
                                iconLeft="fa fa-floppy-o pe-3"
                                (click)="validateSave()"
                                [isDisabled]="currentScenario.isLoading"
                            ></stButton>

                            <span class="ms-4">
                                <i
                                    [hidden]="!waiter.save.progress"
                                    class="fa fa-spinner fa-spin fa-lg fa-fw"
                                ></i>
                                <i
                                    [hidden]="!waiter.save.ok"
                                    class="fa fa-check fa-lg text-st-success"
                                    aria-hidden="true"
                                ></i>
                                <i
                                    [hidden]="!waiter.save.error"
                                    class="fa fa-exclamation-triangle fa-lg text-st-danger"
                                    aria-hidden="true"
                                ></i>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="loading my-4" *ngIf="currentScenario.isLoading">
                    <div
                        class="alert alert-info mb-0 d-flex align-items-center justify-content-center"
                        role="alert"
                    >
                        L'étude &laquo; {{ currentScenario.name }} &raquo; est en cours de
                        chargement. Veuillez patienter.
                        <i class="fa fa-spinner fa-pulse fa-2x ms-3"></i>
                    </div>
                </div>

                <h5 class="st-fw-bold">Gérer les études</h5>

                <form *ngIf="scenarios?.length">
                    <div class="container-fluid mb-2">
                        <div class="row">
                            <div class="col-sm-auto">
                                <div class="row">
                                    <div class="col px-0 position-relative">
                                        <input
                                            id="table-complete-search"
                                            type="text"
                                            class="form-control px-5"
                                            name="searchTerm"
                                            [(ngModel)]="stTableService.searchTerm"
                                            placeholder="Rechercher"
                                        />
                                        <i
                                            class="fa fa-search position-absolute top-50 translate-middle-y"
                                        ></i>
                                    </div>
                                </div>
                            </div>
                            <span class="col col-form-label" *ngIf="stTableService.loading$ | async"
                                >Chargement...</span
                            >
                        </div>
                    </div>

                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th
                                    scope="col"
                                    sortable="id"
                                    (sort)="onSort($event)"
                                    class="id-col"
                                >
                                    ID
                                </th>
                                <th
                                    scope="col"
                                    sortable="name"
                                    (sort)="onSort($event)"
                                    class="name-col"
                                >
                                    Nom du scénario
                                </th>
                                <th
                                    scope="col"
                                    sortable="creatorUserName"
                                    (sort)="onSort($event)"
                                    class="creatorUserName-col"
                                >
                                    Crée par
                                </th>
                                <th
                                    scope="col"
                                    sortable="dateCreatedTime"
                                    (sort)="onSort($event)"
                                    class="dateCreated-col"
                                >
                                    Le
                                </th>
                                <th
                                    scope="col"
                                    sortable="lastModifierUserName"
                                    (sort)="onSort($event)"
                                    class="lastModifierUserName-col"
                                >
                                    Modifié par
                                </th>
                                <th
                                    scope="col"
                                    sortable="dateLastModifiedTime"
                                    (sort)="onSort($event)"
                                    class="dateLastModified-col"
                                >
                                    Le
                                </th>
                                <th scope="col" class="handling-col">Gestion</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let scenario of scenarios$ | async">
                                <td scope="row">
                                    <ngb-highlight
                                        [result]="scenario.id"
                                        [term]="stTableService.searchTerm"
                                    >
                                    </ngb-highlight>
                                </td>
                                <td>
                                    <ngb-highlight
                                        [result]="scenario.name"
                                        [term]="stTableService.searchTerm"
                                    >
                                    </ngb-highlight>
                                    <span class="ms-5">
                                        <ng-container *ngFor="let plugin of scenario.plugins">
                                            <ng-container *ngIf="plugin == 'prosper_reseaux'">
                                                <span
                                                    class="prosper-reseaux-icon"
                                                    ngbTooltip="PROSPER Réseaux électrique"
                                                    placement="bottom"
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 400 481"
                                                    >
                                                        <path
                                                            stroke="none"
                                                            fill-rule="evenodd"
                                                            d="M223.516 31.339 C 210.078 44.777,210.771 63.357,225.203 76.584 L 234.282 84.904 230.494 104.500 C 228.410 115.278,222.742 144.970,217.897 170.482 L 209.089 216.867 200.198 216.867 C 189.312 216.867,167.340 227.445,162.324 235.100 L 158.637 240.727 140.764 231.883 C 125.503 224.332,122.892 222.139,122.892 216.875 C 122.892 196.612,92.600 188.594,80.627 205.688 C 66.771 225.470,90.128 252.050,111.375 240.679 C 115.520 238.461,119.256 239.362,132.504 245.771 L 148.599 253.557 148.396 270.754 C 148.284 280.213,148.735 290.542,149.398 293.708 C 150.486 298.906,147.018 301.676,113.561 322.327 L 76.520 345.190 68.299 341.270 C 37.095 326.390,7.532 353.904,21.550 384.780 C 35.991 416.586,80.285 406.220,84.246 370.108 L 85.542 358.288 122.479 335.529 L 159.416 312.770 164.648 317.559 C 180.235 331.827,208.853 336.950,228.083 328.916 C 232.840 326.928,237.544 325.301,238.535 325.301 C 240.064 325.301,283.369 372.575,300.698 393.163 C 306.135 399.623,306.157 399.894,302.208 411.966 C 289.298 451.436,335.601 481.634,366.386 453.821 C 400.091 423.371,363.649 369.897,321.576 388.068 C 320.189 388.667,303.738 372.063,285.018 351.170 L 250.981 313.183 256.983 302.445 C 260.337 296.443,263.591 285.827,264.360 278.376 L 265.736 265.046 277.564 261.534 C 288.127 258.397,290.253 258.432,297.454 261.866 C 322.742 273.925,339.617 240.369,315.165 226.645 C 306.663 221.873,296.819 225.319,290.377 235.324 C 285.316 243.183,260.023 253.120,258.203 247.964 C 256.297 242.564,244.011 230.095,234.882 224.294 L 225.090 218.072 237.395 152.459 C 244.163 116.372,250.174 86.521,250.754 86.123 C 251.333 85.725,255.820 83.577,260.725 81.349 C 292.724 66.817,280.759 21.723,244.897 21.696 C 234.418 21.688,232.140 22.715,223.516 31.339 M344.122 412.690 C 344.692 417.490,346.405 419.163,351.330 419.734 C 360.949 420.848,361.422 428.559,351.989 430.446 C 346.211 431.601,344.578 433.188,344.578 437.651 C 344.578 441.767,343.226 443.373,339.759 443.373 C 336.225 443.373,334.940 441.767,334.940 437.349 C 334.940 433.063,333.635 431.325,330.416 431.325 C 324.989 431.325,319.444 425.315,321.622 421.792 C 322.476 420.409,325.823 419.277,329.058 419.277 C 333.613 419.277,334.940 418.009,334.940 413.655 C 334.940 402.810,342.848 401.979,344.122 412.690"
                                                        />
                                                    </svg>
                                                </span>
                                            </ng-container>
                                        </ng-container>
                                    </span>
                                </td>
                                <td>
                                    <ngb-highlight
                                        [result]="scenario.creatorUserName"
                                        [term]="stTableService.searchTerm"
                                    >
                                    </ngb-highlight>
                                </td>
                                <td>
                                    <ngb-highlight
                                        [result]="scenario.dateCreated"
                                        [term]="stTableService.searchTerm"
                                    >
                                    </ngb-highlight>
                                </td>
                                <td>
                                    <ngb-highlight
                                        [result]="scenario.lastModifierUserName"
                                        [term]="stTableService.searchTerm"
                                    >
                                    </ngb-highlight>
                                </td>
                                <td>
                                    <ngb-highlight
                                        [result]="scenario.dateLastModified"
                                        [term]="stTableService.searchTerm"
                                    >
                                    </ngb-highlight>
                                </td>
                                <td>
                                    <div
                                        [ngClass]="{'justify-content-around': isScenarioAvailable(user, scenario)}"
                                    >
                                        <ng-template #tooltipContent>
                                            <div>Ouvrir</div>
                                        </ng-template>
                                        <span
                                            (click)="getScenario(scenario)"
                                            class="fa fa-folder-open-o cursor-pointer"
                                            style="padding: 5px"
                                            [ngbTooltip]="tooltipContent"
                                        ></span>
                                        <ng-template #tooltipContentUp>
                                            <div>Modifier</div>
                                        </ng-template>
                                        <span
                                            *ngIf="isScenarioAvailable(user, scenario)"
                                            class="fa fa-pencil-square-o cursor-pointer"
                                            (click)="update(scenario)"
                                            style="padding: 5px"
                                            [ngbTooltip]="tooltipContentUp"
                                        ></span>
                                        <ng-template #tooltipContentDel>
                                            <div>Supprimer</div>
                                        </ng-template>
                                        <span
                                            *ngIf="isScenarioAvailable(user, scenario)"
                                            class="fa fa-trash-o cursor-pointer"
                                            (click)="delete(scenario)"
                                            style="padding: 5px"
                                            [ngbTooltip]="tooltipContentDel"
                                        ></span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="d-flex justify-content-between py-2">
                        <ngb-pagination
                            [collectionSize]="(total$ | async)!"
                            [(page)]="stTableService.page"
                            [pageSize]="stTableService.pageSize"
                            [maxSize]="5"
                            [rotate]="true"
                            [boundaryLinks]="true"
                        >
                        </ngb-pagination>

                        <select
                            class="form-select selectPageSize"
                            name="pageSize"
                            [(ngModel)]="stTableService.pageSize"
                        >
                            <option
                                [ngValue]="value"
                                *ngFor="let value of stTableService.pageSizeOptions"
                            >
                                {{ value }}
                            </option>
                        </select>
                    </div>
                </form>
            </div>

            <div [hidden]="viewMode === 'list'">
                <div class="container-fluid">
                    <form novalidate>
                        <div class="row d-flex align-items-center justify-content-center mb-3">
                            <label
                                for="new-study-name"
                                class="col-1 control-label text-start fw-normal py-2"
                            >
                                Nom<sup>*</sup>
                            </label>
                            <div class="col-3">
                                <stInput
                                    inner-id="new-study-name"
                                    type="text"
                                    class="primary"
                                    name="_nom"
                                    [(ngModel)]="currentScenario.name"
                                    placeholder="Mon étude"
                                    required
                                ></stInput>
                            </div>
                        </div>

                        <div class="row d-flex align-items-center justify-content-center mb-3">
                            <label
                                for="new-study-right"
                                class="col-1 control-label text-start fw-normal py-2"
                            >
                                Droits
                            </label>
                            <div class="col-3">
                                <div class="btn-group w-100" ngbDropdown>
                                    <button
                                        type="button"
                                        class="btn btn-st-primary dropdown-toggle w-100"
                                        ngbDropdownToggle
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        <span>{{ selectedRight.label }}</span>
                                        <span class="caret align-center-right"></span>
                                    </button>
                                    <ul class="dropdown-menu w-100" ngbDropdownMenu>
                                        <li
                                            ngbDropdownItem
                                            *ngFor="let right of rights | sortBy: 'id'"
                                            (click)="updateRight(right)"
                                        >
                                            <a>
                                                <small>{{ right.label }}</small>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <stButton
                btnLabel="Fermer"
                btnClass="btn-st-default"
                (click)="activeModal.dismiss(); onClose()"
                [hidden]="viewMode != 'list'"
                [isDisabled]="currentScenario.isLoading"
            >
            </stButton>

            <div [hidden]="viewMode === 'list'">
                <stButton
                    btnLabel="Annuler"
                    btnClass="btn-st-default me-3 px-5"
                    (click)="backToMain()"
                ></stButton>
                <stButton
                    btnLabel="Valider"
                    btnClass="btn-st-primary ms-3 px-5"
                    [isDisabled]="!selectedRight.id"
                    (click)="validateCreate()"
                    [hidden]="viewMode != 'create'"
                >
                </stButton>

                <stButton
                    btnLabel="Valider"
                    btnClass="btn-st-primary ms-3 px-5"
                    [isDisabled]="!selectedRight.id"
                    (click)="validateUpdate()"
                    [hidden]="viewMode != 'update'"
                >
                </stButton>
            </div>
        </div>
    </ng-container>
</div>
